class ATInternetService {
  private tag: any
  constructor() {
    this.tag = this.newTag({ secure: true })
  }

  // @param info: {name: string, level2?: string, chapter1?: string, chapter2?: string, chapter3?: string, customObject?: any}
  public sendPage(info) {
    this.tag.page.set(info)
    this.tag.dispatch()
  }
  // @param info: {elem: any, name: string, level2?: string, chapter1?: string, chapter2?: string, chapter3?: string, type: string, customObject?: any}
  public sendClick(info) {
    this.tag.click.send(info)
  }
  private newTag(options) {
    try {
      // @ts-ignore
      return new ATInternet.Tracker.Tag(options)
    } catch (ex) {
      return {
        dispatch: () => ({}),
        page: { set: () => ({}) },
        click: { send: () => ({}) },
      }
    }
  }
}

export let tag = new ATInternetService()



// WEBPACK FOOTER //
// ./src/services/ATInternetService.ts